<template lang="html">
  <div class="tracks-new">
    <form
      class="list inline-labels no-hairlines-md"
      @submit.prevent="submit">
      <ul>
        <ItemInput
          media
          label="URL"
          clearable>
          <AtlasIcon class="media-icon" name="001-map" slot="media" />
          <input
            type="text"
            name="track"
            placeholder="Fichier GPX/KML"
            v-model="url">
        </ItemInput>
      </ul>
    </form>

    <f7-block>
      <f7-button
        fill
        @click="save">
        {{ t('ui.save') }}
      </f7-button>
    </f7-block>

    <pre>{{ track }}</pre>
  </div>
</template>

<script>
export default {
  name: 'TracksNew',
  data () {
    return {
      url: '',
      track: {}
    }
  },
  sockets: {
    setTrack (data) {
      console.log('data received')
      this.track = data
    }
  },
  methods: {
    save () {
      this.$socket.emit('getTrack', this.url)
      // getTrack(this.url).then(res => {
      //   console.log(res)
      //   this.track = res
      // })
      // if (this.url) {
      //   if (isURL(this.url)) {
      //     getTrack(this.url).then(res => {
      //       console.log(res)
      //       this.track = res
      //     })
      //   } else {
      //     this.$f7.notification.create({
      //       title: 'Erreur !',
      //       text: 'Url non valide',
      //       closeTimeout: 3000
      //     }).open()
      //   }
      // }
    }
  }
}
</script>

<style lang="css">
</style>
